export default __webpack_public_path__ + "static/highlight-cc508d24a69a9eef1a8e706a713eaff5.png";